import { Avatar, Popover } from 'antd';
import dayjs from 'dayjs';
// @ts-ignore getCountryISO2
import getCountryISO2 from 'country-iso-3-to-2';
import { useParams } from 'react-router-dom';
import { User as UserType } from '../../../store/auth';
import { getUserDisplayName } from '../Chat/utils';
import BusinessOwnerBadge from '../BuisinessOwnerBadge';
import useRelativeDate from '../../../hooks/useRelativeDate';
import UserBadge from '../UserBadge';

import styles from './index.module.scss';

const getFlagUrlFromIso3 = (iso3?: string | null): string | null => {
  if (!iso3) return null;
  const iso2: string = getCountryISO2(iso3);

  return iso2 ? `https://purecatamphetamine.github.io/country-flag-icons/3x2/${iso2}.svg` : null;
};

const getInitials = (user?: UserType | null) => (user
  ? getUserDisplayName(user)
    .split(' ')
    .map((chank) => chank[0])
    .filter(Boolean)
    .slice(0, 2)
    .join('')
    .toUpperCase()
  : '');

function WorkerBadge() {
  return <UserBadge text="Tipped Worker" color="black" />;
}

interface UserProps {
  user: UserType | null | undefined;
  date?: string | null;
  isOwner?: boolean;
}

function User({
  user, date, isOwner,
}: UserProps) {
  const { subCategoryId = '' } = useParams();
  const isWorker = user?.subCategory?.id === subCategoryId;

  const relativeDate = useRelativeDate(date);

  /** For popover content: */
  function renderUser() {
    return (
      <div className={styles.author}>
        <Avatar
          className={styles.avatar}
          src={user?.photo?.location}
          icon={(
            <span className={styles.avatarIcon}>
              {getInitials(user)}
            </span>
          )}
        />
        <div className={styles.info}>
          <div className={styles.name}>
            {user && getUserDisplayName(user)}
            {user?.country?.iso3 && (
              <img
                src={getFlagUrlFromIso3(user.country.iso3) || ''}
                alt="flag"
                className={styles.flag}
                width={24}
                height={16}
              />
            )}

            {user?.category?.file?.location ? (
              <img
                className={styles.categoryIcon}
                src={user?.category.file.location}
                alt={user?.category.name}
              />
            ) : null}
            {isOwner && <BusinessOwnerBadge />}
            {isWorker && <WorkerBadge />}
          </div>

          {date && (
            <div className={styles.date}>
              {relativeDate}
            </div>
          )}
        </div>
      </div>
    );
  }
  const popoverContent = (
    <div className={styles.popoverContent}>
      {renderUser()}

      <div className={styles.item}>
        <span className={styles.title}>Personal Info</span>
        <div>
          <span className={styles.smallTitle}>Member since</span>
          <h4>{dayjs(user?.createdAt).format('MMMM DD, YYYY')}</h4>
        </div>
      </div>
      {user?.description ? (
        <div className={styles.item}>
          <span className={styles.title}>About Me</span>
          <span className={styles.desc}>{user?.description}</span>
        </div>
      ) : null}
    </div>
  );

  return (
    <div className={styles.author}>
      <Popover content={popoverContent} trigger="hover">
        <Avatar
          className={styles.avatar}
          src={user?.photo?.location}
          icon={(
            <span className={styles.avatarIcon}>
              {getInitials(user)}
            </span>
          )}
        />
      </Popover>

      <div className={styles.info}>
        <div className={styles.name}>
          {user && getUserDisplayName(user)}
          {user?.country?.iso3 ? (
            <img
              src={getFlagUrlFromIso3(user.country.iso3) || ''}
              alt="flag"
              className={styles.flag}
              width={24}
              height={16}
            />
          ) : null}
          {user?.category?.file?.location ? (
            <img
              className={styles.categoryIcon}
              src={user?.category.file.location}
              alt={user?.category.name}
            />
          ) : null}
        </div>

        {date && (
          <div className={styles.date}>
            {relativeDate}
          </div>
        )}
      </div>
      <div className={styles.flexStart}>{isOwner && <BusinessOwnerBadge />}</div>
      <div className={styles.flexStart}>{isWorker && <WorkerBadge />}</div>
    </div>
  );
}

export default User;
